module.exports = __webpack_public_path__ + "static/media/apple-app.92bf1e46.png";